export default __webpack_public_path__ + "static/media/MongoDB.90f9478c.svg";